export const ROLES = {
  EMPLOYEE: 'EMPLOYEE',
  TEAM_MEMBER: 'TEAM_MEMBER',
  TEAM_LEAD: 'TEAM_LEAD',
  BRANCH_HEAD: 'BRANCH_HEAD',
  DEPARTMENT_HEAD: 'DEPARTMENT_HEAD',
  HR_MANAGER: 'HR_MANAGER',
  ACCOUNTING_STAFF: 'ACCOUNTING_STAFF',
  LEGAL_STAFF: 'LEGAL_STAFF',
  MANAGER: 'MANAGER',
  GENERAL_MANAGER: 'GENERAL_MANAGER',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

export const RECORD_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  MODIFIED: 'MODIFIED',
};
export const canViewDepartmentDashboard = (role) => {
  return [ROLES.DEPARTMENT_HEAD, ROLES.GENERAL_MANAGER, ROLES.SUPER_ADMIN].includes(role);
};

export const isManager = (role) => {
  return [ROLES.MANAGER, ROLES.GENERAL_MANAGER, ROLES.SUPER_ADMIN].includes(role);
};

export const isGeneralManager = (role) => {
  return [ROLES.GENERAL_MANAGER, ROLES.SUPER_ADMIN].includes(role);
};

export const canViewEmployeeColumn = (role) => {
  return isManager(role);
};

export const canViewRow = (
  role,
  rowEmployeeId,
  currentUserId,
  subordinateIds = [],
  rowDeptId = null,
  userDeptId = null
) => {
  if (isGeneralManager(role)) {
    return true;
  }

  if (role === ROLES.MANAGER) {
    const isSubordinate = subordinateIds.includes(rowEmployeeId);
    const isDeptAction = rowDeptId && rowDeptId === userDeptId;
    return isSubordinate || isDeptAction;
  }

  const isPersonalAction = rowEmployeeId === currentUserId;
  const isDeptAction = rowDeptId && userDeptId && rowDeptId === userDeptId;

  return isPersonalAction || isDeptAction;
};

export const canEditPlanned = (role, status) => {
  return false;
};

export const canEditPresented = (role, status, isOwnRecord) => {
  if (role === ROLES.EMPLOYEE) {
    return isOwnRecord && ![RECORD_STATUS.APPROVED, RECORD_STATUS.MODIFIED].includes(status);
  }

  if (role === ROLES.MANAGER) {
    return status === RECORD_STATUS.PENDING;
  }

  return false;
};

export const canSubmitRecord = (role, status, isOwnRecord) => {
  if (role === ROLES.EMPLOYEE) {
    return isOwnRecord && ![RECORD_STATUS.APPROVED, RECORD_STATUS.MODIFIED].includes(status);
  }

  return false;
};

export const canApproveRecord = (role, status) => {
  return role === 'MANAGER' && status === 'PENDING';
};

export const canReviewRecord = (role, status) => {
  return role === 'MANAGER' && status === 'SUBMITTED';
};

export const canEditActual = (role, status) => {
  return role === 'MANAGER' && status === 'APPROVED';
};

export const getUserRole = (userInfo) => {
  if (!userInfo) return null;

  const userRole = userInfo.role || userInfo.userType || '';

  const normalizedRole = userRole.toString().toUpperCase().replace(/\s+/g, '_');

  const roleMapping = {
    EMPLOYEE: ROLES.EMPLOYEE,
    TEAM_MEMBER: ROLES.TEAM_MEMBER,
    TEAM_LEAD: ROLES.TEAM_LEAD,
    BRANCH_HEAD: ROLES.BRANCH_HEAD,
    DEPARTMENT_HEAD: ROLES.DEPARTMENT_HEAD,
    HR_MANAGER: ROLES.HR_MANAGER,
    ACCOUNTING_STAFF: ROLES.ACCOUNTING_STAFF,
    LEGAL_STAFF: ROLES.LEGAL_STAFF,
    MANAGER: ROLES.MANAGER,
    GENERAL_MANAGER: ROLES.GENERAL_MANAGER,
    GM: ROLES.GENERAL_MANAGER,
    SUPER_ADMIN: ROLES.SUPER_ADMIN,
    ADMIN: ROLES.SUPER_ADMIN,
  };

  return roleMapping[normalizedRole] || ROLES.EMPLOYEE;
};

export const isRecordLocked = (status) => {
  return [RECORD_STATUS.APPROVED, RECORD_STATUS.MODIFIED].includes(status);
};
export const getPermissions = (role, status, isOwnRecord) => {
  const isEmployee = role === ROLES.EMPLOYEE || role === ROLES.TEAM_MEMBER;
  const isManager = role === ROLES.MANAGER;

  return {
    canEditPres: isOwnRecord,

    canSubmit: isEmployee && isOwnRecord && (status === 'PENDING' || status === 'MODIFIED'),

    canApprove: isManager && status === 'PENDING' && !isOwnRecord,

    canReview: isManager && status === 'SUBMITTED',

    canEditActual: isManager && status === 'APPROVED',
  };
};
